
export default {
  name: 'AllFurnitureViewTop',
  props: {
    categories: {
      type: Array,
      required: true,
    },
    deviceSpecificBanner: {
      type: Array,
    },
  },
  methods: {
    scrollToCategory(categoryId) {
      this.$emit('scroll-to-category', categoryId);
    },
  },
  head() {
    return {
      style: [
        {
          cssText: this.deviceSpecificBanner[0]?.content?.style,
          type: 'text/css',
        },
      ],
    };
  },
};
